import React from 'react';

/* Common */
import { Icon } from '~/components/common';

/* Icons */
import iDealIcon from '~/../symbols/iDeal.svg';

export default function ConversionFlowSummary({ summary }) {
    return (
        <div className="row gutters-4 gutters-lg-6">
            {Object.entries(summary?.categories || {})?.map(([key, category]) => (
                <div key={key} className="col-12">
                    <div className="row gutters-1">
                        {category?.title && (
                            <div className="col-12">
                                <p className="font-weight-bold">
                                    {category?.title}
                                </p>
                            </div>
                        )}

                        {Object.entries(category?.values || {})?.map(([key, value]) => (
                            <React.Fragment key={key}>
                                <div className="col-6">
                                    <p className="text--sm">{value?.label}</p>
                                </div>
                                <div className="col-6 d-flex">
                                    <p className="text--sm font-weight-bold">{value?.value}</p>
                                    {(value?.iconType && value.iconType === 'ideal') && (
                                        <Icon
                                            theme="base"
                                            className={`icon icon--32 ml-2 flex-shrink-0`}
                                            url={iDealIcon?.url}
                                        />
                                    )}
                                </div>
                            </React.Fragment>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    )
}
